// src/config.js
const config = {
    API_URL: process.env.REACT_APP_API_URL || 'https://api.subtidal.com',
  };

  export default config;